var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_95",
    "data-name": "Group 95",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.452,
    height: 11.933,
    viewBox: "0 0 11.452 11.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "expand-start-svgrepo-com",
    transform: "translate(11.452 5) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M4.472,5.726h0L0,10.245l1.207,1.207L6.933,5.726,1.207,0,0,1.207Z",
    fill: "#808080",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "expand-start-svgrepo-com-2",
    "data-name": "expand-start-svgrepo-com",
    transform: "translate(11.452 0) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2-2",
    "data-name": "Path 2",
    d: "M4.472,5.726h0L0,10.245l1.207,1.207L6.933,5.726,1.207,0,0,1.207Z",
    fill: "#808080",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowNew);
export default __webpack_public_path__ + "static/media/down-arrow-new.22ad796864e5c252365b8efb98f9b4d6.svg";
export { ForwardRef as ReactComponent };